import { useDispatch } from 'react-redux'
import {
  setSystemConfig,
  setSystemConfigLoading,
  setSystemConfigError,
} from 'store/systemConfig/systemConfigSlice'
import { apiGetSystemConfiguration } from 'services/SecurityService'
import { OPERATING_MODE } from 'constants/system.constant'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

function useSystem() {
  const dispatch = useDispatch()
  const systemConfig = useSelector((state) => state.systemConfig?.data || null)
  const getSystemConfig = async (licenseKey) => {
    dispatch(setSystemConfigLoading(true))
    try {
      const configResponse = await apiGetSystemConfiguration({ licenseKey })
      const systemConfig = JSON.parse(configResponse?.data)
      if (systemConfig?.[0]) {
        dispatch(
          setSystemConfig({
            operatingMode: systemConfig?.[0]?.operating_mode,
            //operatingMode: OPERATING_MODE.MPX_HOST,
            wmsMode: systemConfig?.[0]?.wms_mode,
            licenseName: systemConfig?.[0]?.license_name,
            welcomeMessage: systemConfig?.[0]?.welcome_message,
            licenseExpired: systemConfig?.[0]?.license_expired,
            licenseExpiryDate: systemConfig?.[0]?.license_expiry_date,
          })
        )
      }
    } catch (error) {
      dispatch(
        setSystemConfigError(
          error?.message || 'Failed to load system configuration'
        )
      )
    }
  }
  const isMpxBatch = useMemo(() => {
    return systemConfig?.operatingMode === OPERATING_MODE.MPX_BATCH
  }, [systemConfig])

  const isMpxEnterprise = useMemo(() => {
    return systemConfig?.operatingMode === OPERATING_MODE.MPX_ENTERPRISE
  }, [systemConfig])

  const wmsMode = useMemo(() => {
    return systemConfig?.wmsMode
  }, [systemConfig])

  return {
    systemConfig,
    getSystemConfig,
    isMpxBatch,
    isMpxEnterprise,
    wmsMode
  }
}

export default useSystem
